function onloadCheked() {
    const toggles = [
    document.getElementById('modeToggle1'),
    document.getElementById('modeToggle2')
  ].filter(Boolean); // remove nulls safely

  const header = document.querySelector('header');

  // Restore saved state
  const isActive = localStorage.getItem('headerToggle') === "on";

  toggles.forEach(toggle => {
    toggle.checked = isActive;
    //   const toggleSwitch = document.querySelectorAll('.custom-toggle-switch');
    // // toggleSwitch.style.opacity = '1';
    //   toggleSwitch.forEach(el => {
    //     el.style.opacity = '1';
    //   });
  });

  header?.classList.toggle('active-toggle', isActive);

  // Sync toggles + save
  toggles.forEach(toggle => {
    toggle.addEventListener('change', () => {
      const checked = toggle.checked;

      // Sync both toggles
      toggles.forEach(t => t.checked = checked);

      // Apply class
      header?.classList.toggle('active-toggle', checked);

      // Save state
      localStorage.setItem('headerToggle', checked ? 'on' : 'off');
    });
  });
  setTimeout(() => {
    document.body.classList.remove('mode_toggle_body');  
  });
  const header__inline = document.querySelectorAll('.header__inline-menu');
  const toggleSwitch = document.querySelectorAll('.custom-toggle-switch');
  header__inline.forEach(el => {
    el.style.opacity = '1';
  });

  setTimeout(() => {
    toggleSwitch.forEach(el => {
      el.style.opacity = '1';
    });
  }, 250); 
}

  (function () {
    onloadCheked();
  })();   


var $=jQuery;
jQuery(document).ready(function ($) {

  function formatMoney(cents) {
    // return (cents / 100).toFixed(2).toLocaleString('de-DE') + '€\u00A0';
    return (cents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }
  
  // cusom variant //

  // Custom variant image preview/persist per product card
// - Hover: preview only, revert to current "base" image on mouseleave
// - Click: persist, and update "base" image to the clicked option

function setCardImages($card, url) {
  var $mediaImgs = $card.find('.media--hover-effect img');
  $mediaImgs.each(function () {
    $(this).attr('src', url).attr('srcset', url);
  });
}

function cacheBaseImages($card) {
  var $mediaImgs = $card.find('.media--hover-effect img');

  // Cache base src/srcset once
  $mediaImgs.each(function () {
    var $img = $(this);
    if (!$img.attr('data-base-src')) $img.attr('data-base-src', $img.attr('src') || '');
    if (!$img.attr('data-base-srcset')) $img.attr('data-base-srcset', $img.attr('srcset') || '');
  });
}

function updateBaseImagesTo($card, url) {
  var $mediaImgs = $card.find('.media--hover-effect img');
  $mediaImgs.each(function () {
    var $img = $(this);
    $img.attr('data-base-src', url);
    $img.attr('data-base-srcset', url);
  });
}

function revertToBase($card) {
  var $mediaImgs = $card.find('.media--hover-effect img');
  $mediaImgs.each(function () {
    var $img = $(this);
    var baseSrc = $img.attr('data-base-src');
    var baseSrcset = $img.attr('data-base-srcset');

    if (typeof baseSrc !== 'undefined') $img.attr('src', baseSrc);
    if (typeof baseSrcset !== 'undefined') $img.attr('srcset', baseSrcset);
  });
}

// Hover preview
$(document).on('mouseenter', '.card-variant-sizes .size-label', function () {
  var $label = $(this);
  var $swatch = $label.find('.color-custom.color-option');
  var newImage = $swatch.attr('data-image');
  if (!newImage) return;

  var $card = $label.closest('.card');
  cacheBaseImages($card);

  setCardImages($card, newImage);

  $card.find('.color-custom.color-option').removeClass('selected');
  $swatch.addClass('selected');

}).on('mouseleave', '.card-variant-sizes .size-label', function () {
  var $label = $(this);
  var $card = $label.closest('.card');

  // Always revert to the current base image (which may be updated by click)
  revertToBase($card);

  // Restore "selected" state based on active/checked option (optional)
  var $active = $card.find('.card-variant-sizes .size-label.active .color-custom.color-option');
  $card.find('.color-custom.color-option').removeClass('selected');
  if ($active.length) $active.addClass('selected');
});

// Click persist + update base
$(document).on('click', '.card-variant-sizes .size-label', function () {
  var $label = $(this);
  var $swatch = $label.find('.color-custom.color-option');
  var newImage = $swatch.attr('data-image');
  if (!newImage) return;

  var $card = $label.closest('.card');
  cacheBaseImages($card);

  // Update UI active state (optional)
  $card.find('.card-variant-sizes .size-label').removeClass('active');
  $label.addClass('active');

  // Persist image
  setCardImages($card, newImage);

  // IMPORTANT: update base image to the clicked image
  updateBaseImagesTo($card, newImage);

  $card.find('.color-custom.color-option').removeClass('selected');
  $swatch.addClass('selected');
});

// Auf Collection-Seiten verfügbare 100 ml vorauswählen.
// Bild, Preis und Warenkorb-ID gemeinsam aktualisieren.
$(function () {
  // Unterstützt auch Sprachpräfixe wie /de/collections/...
  if (!/(^|\/)collections(\/|$)/.test(window.location.pathname)) return;

  // Nicht nur die Markierung ändern, wenn die Variantenfunktion fehlt.
  if (typeof window.updateCardVariant !== 'function') {
    console.warn('100-ml-Vorauswahl: updateCardVariant ist nicht verfügbar.');
    return;
  }

  $('.card-variant-sizes').each(function () {
    var $group = $(this);

    var $input = $group
      .find('input[type="radio"][name^="variant-"]')
      .filter(function () {
        return !this.disabled &&
          this.value.toLowerCase().replace(/\s+/g, '') === '100ml';
      })
      .first();

    if (!$input.length) return;

    var $label = $input.closest('.size-label');
    var $card = $label.closest('.card');
    var $swatch = $label.find('.color-custom.color-option');
    var imageUrl = $swatch.attr('data-image');

    // Ohne Bildzuordnung keine unvollständige Vorauswahl setzen.
    if (!$card.length || !imageUrl) return;

    $input.prop('checked', true);

    // Bestehende Funktion: aktive Größe, Preis und Warenkorb-ID.
    window.updateCardVariant($input[0]);

    // Bestehende Bildfunktionen: anzeigen und als Basis speichern.
    cacheBaseImages($card);
    setCardImages($card, imageUrl);
    updateBaseImagesTo($card, imageUrl);

    $card.find('.color-custom.color-option').removeClass('selected');
    $swatch.addClass('selected');
  });
});


  // cusom variant // 
// $(document).on('mouseenter', '.card-variant-sizes .size-label', function() {
//   var $swatch = $(this).find('.color-custom.color-option');
//   var newImage = $swatch.attr('data-image');

//   if (newImage && newImage.length > 0) {
//     var $card = $swatch.closest('.card');
//     var $mediaImgs = $card.find('.media--hover-effect img');

//     // Save original image if not saved
//     $mediaImgs.each(function() {
//       if (!$(this).attr('data-original')) {
//         $(this).attr('data-original', $(this).attr('src'));
//       }
//       $(this).attr('src', newImage);
//       $(this).attr('srcset', newImage);
//     });
//   }
// });

// $(document).on('mouseleave', '.card-variant-sizes .size-label', function() {
//   var $swatch = $(this).find('.color-custom.color-option');
//   var $card = $swatch.closest('.card');
//   var $mediaImgs = $card.find('.media--hover-effect img');

//   $mediaImgs.each(function() {
//     var original = $(this).attr('data-original');
//     if (original) {
//       $(this).attr('src', original);
//       $(this).attr('srcset', original);
//     }
//   });
// });


$(document).on('change', '.select__select', function () {
  
  var $select = $(this);
  var $productItem = $select.closest('.pdp_detail');
  var newImage = $(this).find('option:selected').attr('data-image'); 
  $productItem.find('.pdp-img-crspdp').attr('src', newImage);
  var selectedOptions = [];

  $productItem.find('.select__select').each(function () {
    selectedOptions.push($(this).val());
  });

  var variants = JSON.parse($productItem.attr('data-variants'));

  var matchedVariant = variants.find(function (variant) {
    return variant.options.every(function (opt, index) {
      return opt === selectedOptions[index];
    });
  });

  if (matchedVariant) {
    var $priceContainer = $productItem.find('.price-custom');
    var priceHtml = '';

    if (matchedVariant.compare_at_price > matchedVariant.price) {
     
      priceHtml += '<span class="sale-price">' + formatMoney(matchedVariant.price) + '</span>';
      priceHtml += '<span class="original-price">' + formatMoney(matchedVariant.compare_at_price) + '</span>';
      priceHtml += '<span class="du-sparst">Du sparst ' + formatMoney(matchedVariant.compare_at_price - matchedVariant.price) + '</span>';
    } else {
      priceHtml += '<span class="regular-price">' + formatMoney(matchedVariant.price) + '</span>';
    }
    // priceHtml = priceHtml.replace("€", ' €')
    $priceContainer.html(priceHtml);

    $productItem.find('.product-variant-id').val(matchedVariant.id);
    var $btn = $productItem.find('button[type="submit"]');
    if (matchedVariant.available) {
      $btn.prop('disabled', false);
    } else {
      $btn.prop('disabled', true);
    }
  }
});

  if ($('.product-details-section.quality-details-section .pds-quality-block > div').length > 1) {
    // if ($('.product-details-section.quality-details-section .pds-quality-block > div').length > 3) {
    //   $(".product-details-section.quality-details-section .pds-quality-block").flickity({
    //       prevNextButtons: false,
    //       groupCells: false,
    //       cellAlign: 'left',
    //       adaptiveHeight: true,
    //       contain: true,
    //       pageDots: false,
    //       autoPlay: 3000,
    //   });
    // }else{
    //   $(".product-details-section.quality-details-section .pds-quality-block").flickity({
    //     prevNextButtons: false,
    //     groupCells: false,
    //     cellAlign: 'center',
    //     adaptiveHeight: true,
    //     contain: true,
    //     pageDots: false,
    //     autoPlay: 3000,
    // });
    // }
  }
  $('.category-text').on('click', function() {
    $(this).toggleClass('active');
  });
  $('.nt_qualitat.multicolumn .multicolumn-card__image-wrapper').on('click', function() {
    $(this).closest('.multicolumn-card').toggleClass('active');
    // const $carousel = $(this).closest('.flickity-enabled');

    // if ($carousel.length) {
    //   const flkty = Flickity.data($carousel[0]);
    //   if (flkty) {
    //     flkty.resize();
    //     flkty.reposition();
    //   }
    // }
  });
  $('.hotspot').on('click', function() {
    $(this).toggleClass('active');
  });
  

  function slider_mobile() {
    if($(window).width() <= 949){ 
      
      const $nt_qualitat = $("body .nt_qualitat .grid").flickity({
          initialIndex: 2,
          prevNextButtons: false,
          groupCells: false,
          cellAlign: 'center',
          adaptiveHeight: true,
          contain: true
      });
      // const flkty = $nt_qualitat.data('flickity');

      // $nt_qualitat.on('scroll.flickity', function () {
      //   if (flkty) {
      //     flkty.resize();
      //   }
      // });
      var swiper = new Swiper('.testimonials-slider', {
        slidesPerView: 1,
        spaceBetween:20,
        loop: true,
        centeredSlides: true,
        pagination: {
          el: ".testimonials-slider .swiper-pagination",
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        }
      });
      var swiper = new Swiper('.custom-anouncement-bar', {
        slidesPerView: 1,
        spaceBetween:0,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        }
      });
      var swiper = new Swiper('.slider-mobile-gutter', {
        slidesPerView: 1,
        spaceBetween:30,
        loop: true,
        pagination: {
          el: ".slider-mobile-gutter .swiper-pagination",
        },
        centeredSlides: true,
        // autoplay: {
        //   delay: 5000,
        //   disableOnInteraction: false,
        // }
      });
      
    }
  }
  $(document).ready(slider_mobile);
  $(window).on('resize', function() {
    slider_mobile();
  });
  // add to cart 
    $(document).on('submit', '.js-card-add-to-cart', function(e) {
      e.preventDefault();
      var $form = $(this);
      var formData = new FormData(this);

      var id = formData.get('id');
      
      if (!id) {
        return;
      }

      var $btn = $form.find('[type="submit"]');
      $btn.prop('disabled', true).addClass('loading');

      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(item) {
            var url = new URL(window.location.href);
              url.searchParams.set("open_cart_n", "1");
              window.location.href = url.toString();
        },
        error: function(xhr, status, error) {
        },
        complete: function() {
          // Re-enable button
          $btn.prop('disabled', false).removeClass('loading');
        }
      });
    });
    // add to cart 
 
    $('.fragen_zum_nt').on('click', function() {
    $('#fragen-popup')
      .css('display', 'flex')  
      .hide()                 
      .fadeIn(200);           
  });

  
  $('.popup-close').on('click', function() {
    $('#fragen-popup').fadeOut(200);
  });

  $('#fragen-popup').on('click', function(e) {
    if (e.target === this) {
      $('#fragen-popup').fadeOut(200);
    }
  });

  $('.share-product-btn').on('click', function() {
    console.log('ok1');
    $('#teilen-popup')
      .css('display', 'flex')  
      .hide()                 
      .fadeIn(200);           
  });

  
  $('.popup-close').on('click', function() {
    $('#teilen-popup').fadeOut(200);
  });

  $('#teilen-popup').on('click', function(e) {
    if (e.target === this) {
      $('#teilen-popup').fadeOut(200);
    }
  });


    $(document).on('click', '[data-pagination-btn]', function(e) {
  e.preventDefault();

  const $btn = $(this);
  const nextUrl = $btn.attr('href');
  const $wrapper = $btn.closest('.show_more_btn');

  if (!nextUrl || nextUrl.trim() === '') {
  
    $wrapper.remove();
    return;
  }

  $btn.text("Laden...").prop('disabled', true);

  $.get(nextUrl, function(response) {
    const $tempDiv = $('<div>').html(response);
    const newProductsHtml = $tempDiv.find('#product-grid').html();
    const $newButton = $tempDiv.find('[data-pagination-btn]');
    const nextUrlNew = $newButton.attr('href');

    $('ul#product-grid').append(newProductsHtml);

    if (!nextUrlNew || nextUrlNew.trim() === '') {
      $wrapper.remove(); 
    } else {
      $wrapper.replaceWith($newButton.closest('.show_more_btn'));
    }
  }).fail(function() {
    console.error('Error loading more products.');
    $btn.text("Try again").prop('disabled', false);
  });
});

  // slider pdp
  $("ul.product-single__thumbnails").flickity({
        pageDots: false,
      // freeScroll: false,
      // wrapAround: true,
      prevNextButtons: false,
      autoPlay: false,
      groupCells: true,
      cellAlign: 'left',
      asNavFor: '.product-single__gallery'
  });
  $('.product-single__gallery').flickity({
        imagesLoaded: true,
        groupCells: false,
        dragThreshold: 5,
        cellAlign: 'center',
        wrapAround: true,
        prevNextButtons: true,
        percentPosition: true, 
        pageDots: true,
        rightToLeft: false,
        autoPlay: false,
        sync: '.product-single__thumbnails'
    }); 
  
  $('.product-single__gallery').on('change.flickity', function(event, index) {
      var $thumbnails = $('.product-single__thumbnails li');
      $thumbnails.removeClass('active');  // Remove 'active' class from all thumbnails
      $thumbnails.eq(index).addClass('active');  // Add 'active' class to the current thumbnail
  });
  $('.product-single__thumbnails li').first().addClass('active');
  
  // Thumbnail click event to change the gallery image
  $('.product-single__thumbnails li').on('click', function() {
      var index = $(this).index();
      $('.product-single__gallery').flickity('select', index);  // Select the corresponding image in the gallery
  });
  // slider pdp

  $('.acc-head').on('click', function() {
      if($(this).hasClass('active')) {
        $(this).siblings('.acc-content').slideUp();
        $(this).removeClass('active');
      }
      else {
        $('.acc-content').slideUp();
        $('.acc-head').removeClass('active');
        $(this).siblings('.acc-content').slideToggle();
        $(this).toggleClass('active');
      }
    });

  
  $('footer .has-dropdown .footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });

}); 
// popup up //


document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("custom-popup");
  const closeBtn = document.getElementById("close-popup");

  if (!popup) return;

  const url = new URL(window.location.href);
  const isNewsletterSuccess =
    url.searchParams.get("customer_posted") === "true" &&
    window.location.hash === "#NewsletterForm";

  function openPopup() {
    popup.style.display = "flex";
  }

  function closePopup() {
    popup.style.display = "none";
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      closePopup();
    });
  }

  //  show ss 
  if (isNewsletterSuccess) {
    if (sessionStorage.getItem("popupWasOpenedThisVisit") === "true") {
      openPopup();
    }
    return;
  }

  //  show one
  if (!localStorage.getItem("customPopupShown")) {
    setTimeout(function () {
      openPopup();
      localStorage.setItem("customPopupShown", "true");
      sessionStorage.setItem("popupWasOpenedThisVisit", "true");
    }, 1000);
  }
});


// popup up // 


const params = new URLSearchParams(window.location.search);
if (params.get('open_cart_n') === '1') {
   const cartToggle = document.querySelector('#cart-icon-bubble');
    if (cartToggle) {
      cartToggle.click();
  }
  params.delete('open_cart_n');
  history.replaceState({}, '', `${location.pathname}?${params}`);
}

// const toggles = [
//   document.getElementById('modeToggle1'),
//   document.getElementById('modeToggle2')
// ];
// const header = document.querySelector('header');
// toggles.forEach(toggle => {
//   if (!toggle) return;

//   toggle.addEventListener('change', () => {
//     const isOn = toggles.some(t => t && t.checked);
//     header?.classList.toggle('active-toggle', isOn);
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const toggles = [
//     document.getElementById('modeToggle1'),
//     document.getElementById('modeToggle2')
//   ].filter(Boolean); // remove nulls safely

//   const header = document.querySelector('header');

//   // Restore saved state
//   const isActive = localStorage.getItem('headerToggle') === 'on';

//   toggles.forEach(toggle => {
//     toggle.checked = isActive;
//   });

//   document.body.classList.remove('mode_toggle_body');

//   header?.classList.toggle('active-toggle', isActive);

//   // Sync toggles + save
//   toggles.forEach(toggle => {
//     toggle.addEventListener('change', () => {
//       const checked = toggle.checked;

//       // Sync both toggles
//       toggles.forEach(t => t.checked = checked);

//       // Apply class
//       header?.classList.toggle('active-toggle', checked);

//       // Save state
//       localStorage.setItem('headerToggle', checked ? 'on' : 'off');
//     });
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const header = document.querySelector("header");
//   const toggle = document.getElementById("modeToggle1");

//   // Restore state
//   const saved = localStorage.getItem("headerToggle");
//   if (saved === "on") {
//     header?.classList.add("active-toggle");
//     toggle.checked = true;
//   }

//   // Toggle + save
//   toggle.addEventListener("change", function () {
//     header?.classList.toggle("active-toggle");

//     localStorage.setItem(
//       "headerToggle",
//       toggle.checked ? "on" : "off"
//     );
//   });
// });


// document.addEventListener('DOMContentLoaded', () => {
//   const info = document.querySelector('.product__info-wrapper.grid__item');
//   if (!info) return;

//   requestAnimationFrame(() => {
//     requestAnimationFrame(() => {
//       const rect = info.getBoundingClientRect();
//       info.style.maxHeight =
//         (window.innerHeight - rect.top - 16) + 'px';
//     });
//   });
// });


function copyPageUrl() {
  const url = window.location.href;

  navigator.clipboard.writeText(url)
    .then(() => {
      console.log('URL copied:', url);
    })
    .catch(err => {
      console.error('Failed to copy:', err);
    });
}



// load varaint 
$(window).on('load', function() {
  // Locate the script tag containing variant data
  const scriptTag = $('script[data-selected-variant]').first();

  if (scriptTag.length) {
    try {
      const jsonData = JSON.parse(scriptTag.text().trim());
      const featuredMediaId = jsonData.featured_media?.id;
      const sectionIdValue = $('input[name="section-id"]').val();
      
      // Ensure we have both IDs before proceeding
      if (featuredMediaId && sectionIdValue) {
        const mediaId = `${sectionIdValue}-${featuredMediaId}`;
        const thumbnail = $(`li[data-att="${mediaId}"]`);

        if (thumbnail.length) {
          console.log('Thumbnail found, waiting for Flickity...');

          // --- FIX: Polling mechanism to wait for Flickity initialization ---
          const checkFlickityInterval = setInterval(() => {
            const $gallery = $('.product-single__gallery');
            const flkty = $gallery.data('flickity');

            // Check if Flickity is fully initialized and has cells
            if (flkty && flkty.cells && flkty.cells.length > 0) {
              clearInterval(checkFlickityInterval); // Stop checking
              console.log('Flickity ready. Triggering click.');
              thumbnail.click(); // Trigger the click safely
            }
          }, 100); // Check every 100ms

          // Safety timeout: Stop checking after 5 seconds to prevent infinite loops
          setTimeout(() => {
            clearInterval(checkFlickityInterval);
          }, 1000);
        }
      }
    } catch (e) {
      console.error('Error parsing variant JSON:', e);
    }
  }
});


// load varaint 
document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector('.shopify-section-header-sticky');
  if (!header) return;

  window.addEventListener('scroll', function () {
    if (window.scrollY > 0) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const hash = window.location.hash;
  const params = new URLSearchParams(hash.split('?')[1]);
  const pro = params.get('pro');

  if (hash.includes('profis-tab')) {

    const tabSection = document.querySelector('#profis-tab');

    if (tabSection) {
      const offset = 50;
      const elementPosition = tabSection.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth'
      });
    }
   

    if (pro) {
      const tab = document.querySelector('[data-name="' + pro + '"]');
      if (tab) {
        tab.click(); // or add class active depending on your tab system
        // hide all tab contents
        document.querySelectorAll('.profis-slider.profis-tab .tabs-content .tab-content').forEach(el => {
          el.classList.remove("active")
        });

        // show correct content
        const content = document.querySelector('.profis-slider.profis-tab .tabs-content .tab-content[data-name="' + pro + '"]');
        if (content) {
          content.classList.add("active");
        }
      }
    }
  }
});